module.exports = __webpack_public_path__ + "media/images/emblems/Scharans_wappen-a6061114c382bf0b5e5d6e5a986cbd5e.svg";